export class CustodyType {
  static get EGK () {
    return 1
  }
  static get CUSTOMER () {
    return 2
  }

  static CustodyTypeName (CustodyType) {
    let tmpType = parseInt(CustodyType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = 'EGK'
        break
      case 2:
        name = '客戶'
        break
    }
    return name
  }
}
